var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLowerActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 66,
    viewBox: "0 0 68 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21513_23443)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.390625,
    y: 0.00390625,
    width: 66.2567,
    height: 65.4679,
    rx: 10.254,
    fill: "#898989"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0511 44.6147C13.1705 45.3371 15.6208 49.1752 33.3219 49.1765C51.0229 49.1765 53.4733 45.3371 53.5927 44.6147C53.7171 43.858 53.5609 42.3294 53.2841 40.8427C53.1064 39.8905 52.2786 39.0398 52.0272 38.8049C51.6603 38.4596 50.1952 37.3576 48.1777 37.1633C46.5907 37.0097 45.994 37.3373 45.1421 37.8032C43.7417 38.5713 41.6531 39.7178 33.3219 39.7191C24.9906 39.7191 22.9021 38.5713 21.5017 37.8032C20.6511 37.3373 20.0544 37.0097 18.4673 37.1633C16.4486 37.3576 14.9835 38.4583 14.6153 38.8049C14.3652 39.0398 13.5374 39.8905 13.3596 40.8427C13.0829 42.3307 12.9267 43.858 13.0511 44.6147Z",
    fill: "url(#paint0_radial_21513_23443)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.043 37.681C14.0557 36.7897 14.6118 36.0533 15.1425 35.8591C15.6745 35.6648 16.6737 36.0533 17.3364 36.0533C17.9966 36.0533 18.2328 35.8603 19.011 36.2146C19.7881 36.5688 19.5164 37.5426 19.5164 38.0898C19.5164 38.6357 19.0999 38.8478 18.3178 38.8567C17.5357 38.8655 17.1574 39.0687 16.8794 39.1829C16.6013 39.2972 15.4358 40.0768 14.768 40.0768C14.0989 40.0768 14.0316 38.571 14.0443 37.681H14.043ZM52.2053 37.681C52.1926 36.7897 51.6378 36.0533 51.1071 35.8591C50.5751 35.6648 49.5746 36.0533 48.9132 36.0533C48.2517 36.0533 48.0168 35.8603 47.2385 36.2146C46.4615 36.5688 46.7332 37.5426 46.7332 38.0898C46.7332 38.6357 47.1497 38.8478 47.9317 38.8567C48.7138 38.8655 49.0922 39.0687 49.3702 39.1829C49.6483 39.2972 50.8138 40.0768 51.4816 40.0768C52.1507 40.0768 52.218 38.571 52.2053 37.681Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0434 37.8751C15.0573 36.7579 15.6845 35.6012 16.1314 35.5784C16.8551 35.5022 17.5953 35.9897 18.0828 36.0227C18.5704 36.057 19.6711 35.9428 20.3961 36.3173C21.2543 36.7617 20.9953 37.9678 20.9953 38.6534C20.9953 39.339 20.5357 39.1612 19.6711 39.1714C18.8078 39.1828 18.3888 39.438 18.0828 39.5802C17.7756 39.725 16.8691 40.7229 16.1314 40.7229C15.3925 40.7229 15.0294 38.9924 15.0434 37.8751ZM51.2187 37.8751C51.2047 36.7579 50.5775 35.6012 50.1319 35.5784C49.4069 35.5022 48.668 35.9897 48.1805 36.0227C47.6917 36.057 46.5909 35.9428 45.8672 36.3173C45.0077 36.7617 45.2667 37.9678 45.2667 38.6534C45.2667 39.339 45.7263 39.1612 46.5909 39.1714C47.4542 39.1828 47.8732 39.438 48.1805 39.5802C48.4864 39.725 49.3929 40.7229 50.1319 40.7229C50.8708 40.7229 51.2326 38.9924 51.2187 37.8751Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8788 38.2922C16.828 37.0404 17.2876 35.3569 18.3008 35.607C19.3165 35.8571 19.9081 36.3269 20.6864 36.1072C21.1993 35.9625 21.5878 35.7403 22.2099 36.1072C23.1342 36.6519 23.2345 37.3032 23.2193 38.5271C23.2104 39.2965 22.4207 40.7261 21.4672 40.7794C20.5124 40.834 20.4426 40.0811 20.0808 40.2017C19.6491 40.3465 19.1971 41.4434 18.1103 41.4904C17.0248 41.5374 16.9283 39.5441 16.8788 38.2922ZM49.3722 38.2922C49.423 37.0404 48.9621 35.3569 47.9489 35.607C46.9358 35.8571 46.3429 36.3269 45.5646 36.1072C45.0517 35.9625 44.6632 35.7403 44.0411 36.1072C43.1168 36.6519 43.0165 37.3032 43.0304 38.5271C43.0406 39.2965 43.8303 40.7261 44.7838 40.7794C45.7385 40.834 45.8071 40.0811 46.1702 40.2017C46.6019 40.3465 47.0539 41.4434 48.1394 41.4904C49.2262 41.5374 49.3227 39.5441 49.3722 38.2922Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5521 37.9814C19.5063 35.7799 20.7099 35.1044 21.4514 35.2441C22.1281 35.3723 23.2314 36.5645 23.3812 37.1549C23.5298 37.7427 23.4549 38.978 23.3812 39.7347C23.305 40.4914 22.0938 42.2168 21.2267 42.133C20.3595 42.0493 19.5978 40.1842 19.5521 37.9814ZM46.6978 37.9814C46.7435 35.7799 45.5399 35.1044 44.7985 35.2441C44.1218 35.3723 43.0185 36.5645 42.8686 37.1549C42.7201 37.7427 42.795 38.978 42.8686 39.7347C42.9448 40.4914 44.156 42.2168 45.0232 42.133C45.8903 42.0493 46.6521 40.1842 46.6978 37.9814Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.691 35.9219C23.3891 35.9219 23.4133 37.142 23.4234 37.467C23.4945 39.7485 23.5389 39.7269 23.8348 40.6918C24.0773 41.5171 24.6918 42.7017 25.8458 42.7283C26.9999 42.7562 27.6322 41.5387 27.8493 40.4798C28.0893 39.2737 28.0677 39.52 28.121 37.3362C28.1312 36.9655 27.9788 35.9219 25.691 35.9219ZM40.5557 35.9219C42.8588 35.9219 42.8346 37.142 42.8245 37.467C42.7534 39.7485 42.7077 39.7269 42.4131 40.6918C42.1706 41.5171 41.5561 42.7017 40.4021 42.7283C39.248 42.7562 38.6157 41.5387 38.3973 40.4798C38.1586 39.2737 38.1802 39.52 38.1256 37.3362C38.1167 36.9655 38.2678 35.9219 40.5557 35.9219Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7212 36.0634C28.2797 36.0063 28.1147 36.4722 28.1058 36.7871C28.0487 39.1702 28.3001 40.2836 28.6136 41.2219C28.8739 42.0243 29.4973 43.0806 30.7212 43.1098C31.9451 43.1377 32.5901 42.3455 32.8186 41.3171C33.07 40.1452 33.0675 38.9937 33.1195 36.8709C33.1284 36.5103 33.164 36.1218 30.7212 36.0634Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5596 36.0634C38.0024 36.0063 38.1674 36.4722 38.175 36.7871C38.2334 39.1702 37.9821 40.2836 37.6672 41.2219C37.4082 42.0243 36.7835 43.0806 35.5596 43.1098C34.3357 43.1377 33.6692 42.1792 33.4406 41.1508C33.1892 39.9789 33.2146 38.9937 33.1613 36.8709C33.1537 36.5103 33.1169 36.1218 35.5596 36.0634Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_21513_23443)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.78877,
    y: 0.792676,
    width: 64.6791,
    height: 63.8904,
    rx: 9.46524,
    stroke: "white",
    strokeWidth: 1.57754
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.127,
    cy: 10.6504,
    r: 5.12701,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21513_23443",
    x: -5.91954,
    y: -6.30625,
    width: 78.8781,
    height: 78.0891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21513_23443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21513_23443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21513_23443",
    x: -5.31016,
    y: -6.30625,
    width: 78.8781,
    height: 78.0891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21513_23443"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21513_23443",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21513_23443",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3219 41.0433) scale(32.8514 17.9447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC5C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#FA9FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BC7475"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerActive);
export default __webpack_public_path__ + "static/media/LowerActive.7508194117b069d744a517123a05c8f7.svg";
export { ForwardRef as ReactComponent };